const whatsNewModalStyle = (theme) => ({
  dialogPaper: {
    maxWidth: 680,
    width: '95%',
    maxHeight: '90vh',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      margin: 16,
      width: 'calc(100% - 32px)',
      borderRadius: 12,
      maxHeight: '85vh',
    },
  },
  headerBar: {
    background: 'linear-gradient(135deg, #5850EC 0%, #8B5CF6 50%, #7C3AED 100%)',
    padding: '24px 28px 20px',
    position: 'relative',
    flexShrink: 0,
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      width: 180,
      height: 180,
      background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)',
      borderRadius: '50%',
      transform: 'translate(30%, -30%)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 1,
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 16px',
    },
  },
  headerContent: {
    position: 'relative',
    zIndex: 1,
  },
  closeButton: {
    position: 'absolute',
    top: -6,
    right: -4,
    color: 'rgba(255, 255, 255, 0.85)',
    padding: 8,
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
  headline: {
    color: '#ffffff',
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 1.35,
    margin: 0,
    paddingRight: 40,
    letterSpacing: '-0.02em',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      paddingRight: 32,
    },
  },
  headerSubtitle: {
    color: 'rgba(255, 255, 255, 0.85)',
    fontSize: 14,
    fontWeight: 400,
    margin: '6px 0 0 0',
    paddingRight: 40,
    lineHeight: 1.4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  headerImage: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 60,
    marginTop: 12,
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 40,
    },
  },
  // Scroll hint banner below header (must-scroll mode)
  scrollHint: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '12px 16px',
    backgroundColor: '#E8930C',
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 600,
    flexShrink: 0,
    boxShadow: '0 2px 8px rgba(232, 147, 12, 0.35)',
  },
  content: {
    padding: '20px 28px 20px',
    backgroundColor: '#ffffff',
    overflowY: 'auto',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '16px 20px 14px',
    },
  },
  // Feature card styles
  featureCard: {
    marginBottom: 20,
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    overflow: 'hidden',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  featureHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '14px 16px',
    backgroundColor: '#F5F3FF',
    borderBottom: '1px solid #E5E7EB',
    cursor: 'default',
  },
  featureHeaderCollapsible: {
    cursor: 'pointer',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    font: 'inherit',
    '&:hover': {
      backgroundColor: '#EDE9FE',
    },
  },
  featureHeaderText: {
    flex: 1,
    minWidth: 0,
  },
  featureTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#5850EC',
    lineHeight: 1.4,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  featureDate: {
    fontSize: 12,
    fontStyle: 'italic',
    color: '#9CA3AF',
    marginTop: 2,
    lineHeight: 1.3,
  },
  expandIcon: {
    color: '#6B7280',
    fontSize: 20,
    transition: 'transform 0.2s ease',
    flexShrink: 0,
    marginLeft: 8,
    marginTop: 2,
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
  featureContent: {
    padding: '14px 16px',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 14px',
    },
  },
  // Content block styles
  contentBlockText: {
    color: '#374151',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: 1.7,
    marginBottom: 12,
    '& p': {
      margin: '0 0 8px 0',
    },
    '& p:last-child': {
      marginBottom: 0,
    },
    '& a': {
      color: '#5850EC',
      textDecoration: 'underline',
      '&:hover': {
        color: '#4338CA',
      },
    },
    '& ul, & ol': {
      margin: '4px 0 8px 0',
      paddingLeft: 20,
    },
    '& li': {
      marginBottom: 8,
    },
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  contentBlockImage: {
    marginBottom: 12,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  contentImage: {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    borderRadius: 8,
    border: '1px solid #E5E7EB',
  },
  contentBlockVideo: {
    marginBottom: 12,
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    border: '1px solid #E5E7EB',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    backgroundColor: '#1a1a2e',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    },
  },
  // Expand/collapse more content
  showMoreButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    width: '100%',
    padding: '8px 0',
    fontSize: 13,
    fontWeight: 500,
    color: '#5850EC',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    borderTop: '1px solid #E5E7EB',
    '&:hover': {
      color: '#4338CA',
      backgroundColor: '#F5F3FF',
    },
  },
  showMoreIcon: {
    fontSize: 18,
    transition: 'transform 0.2s ease',
  },
  showMoreIconOpen: {
    transform: 'rotate(180deg)',
  },
  // Inline footer inside scrollable content (must-scroll mode)
  inlineFooter: {
    marginTop: 28,
    padding: '20px 16px 8px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
  },
  dismissCheckboxRowInline: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 14,
    color: '#1E1E2F',
    cursor: 'pointer',
    fontWeight: 500,
    '& input[type="checkbox"]': {
      accentColor: '#5850EC',
      width: 18,
      height: 18,
      cursor: 'pointer',
    },
  },
  closeFooterButtonPrimary: {
    backgroundColor: '#5850EC',
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '10px 32px',
    borderRadius: 8,
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#4338CA',
    },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
  // Sticky footer (normal + history mode)
  footer: {
    borderTop: '1px solid #E5E7EB',
    padding: '14px 28px',
    backgroundColor: '#F9FAFB',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: '12px 20px',
    },
  },
  dismissCheckboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    color: '#6B7280',
    cursor: 'pointer',
    '& input[type="checkbox"]': {
      accentColor: '#5850EC',
      width: 16,
      height: 16,
      cursor: 'pointer',
    },
  },
  closeFooterButton: {
    color: '#9CA3AF',
    fontSize: 13,
    fontWeight: 400,
    textTransform: 'none',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '6px 14px',
    borderRadius: 6,
    transition: 'color 0.15s ease',
    '&:hover': {
      color: '#6B7280',
      backgroundColor: 'transparent',
    },
  },
});

export default whatsNewModalStyle;
